import { type FunctionComponent } from "react";

import subIcon from "images/Common/subIcon.png";

import { type IBTIconProps } from "../BTIcon.types";

export const BTIconDeprecatedSubcontractor: FunctionComponent<IBTIconProps> = ({
    size,
    style,
    className,
}) => {
    const sizeStyles = size ? { height: size, width: size } : {};
    return <img alt="" src={subIcon} style={{ ...sizeStyles, ...style }} className={className} />;
};
